/**
 * Hours, formatted for the Icelandic UI.
 * Raw values in the database remain untouched.
 */

/**
 * Max 2 decimals, trailing zeros trimmed: 4.50 -> "4.5", 4.00 -> "4".
 * Dot decimal. Only use this where a comma would break something
 * (input values, keys); the UI uses formatHoursNum / formatKlst.
 */
export function formatHours(value) {
  const num = Number(value) || 0;
  const rounded = Math.round(num * 100) / 100;
  const str = rounded.toFixed(2);
  return str.replace(/\.?0+$/, '') || '0';
}

/** Icelandic decimal comma, no unit: 89.5 -> "89,5", 8.58 -> "8,58". */
export function formatHoursNum(value) {
  return formatHours(value).replace('.', ',');
}

/** Icelandic hours with the unit: 89.5 -> "89,5 klst", 8 -> "8 klst". */
export function formatKlst(value) {
  return `${formatHoursNum(value)} klst`;
}
